import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "types/message.type";

interface MessageState extends Notification {
  severity?: "error" | "success" | "info" | "warning";
  show: boolean;
  loading: boolean;
}

const initialState: MessageState = {
  show: false,
  loading: false,
};

const alert = (state: MessageState, action: PayloadAction<Notification>) => {
  state.message = action.payload.message;
  state.title = action.payload.title;
  state.show = true;
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    alertSuccess: (state, action: PayloadAction<Notification>) => {
      alert(state, action);
      state.severity = "success";
    },
    alertError: (state, action: PayloadAction<Notification>) => {
      alert(state, action);
      state.severity = "error";
    },
    alertInfo: (state, action: PayloadAction<Notification>) => {
      alert(state, action);
      state.severity = "info";
    },
    alertWarning: (state, action: PayloadAction<Notification>) => {
      alert(state, action);
      state.severity = "warning";
    },
    closeAlert: (state) => {
      state.show = false;
    },
    showLoader: (state) => {
      state.loading = true;
    },
    closeLoader: (state) => {
      state.loading = false;
    },
  },
});

export const {
  alertError,
  alertInfo,
  alertSuccess,
  alertWarning,
  closeAlert,
  closeLoader,
  showLoader,
} = notificationSlice.actions;

const getMessageReducer = (state: any): MessageState => state.message;

export const selectNotification = createSelector(
  getMessageReducer,
  (state) => state
);

export const selectShowLoader = createSelector(
  getMessageReducer,
  (state) => state.loading
);

export default notificationSlice.reducer;
